
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { validationSchema } from "../validationSchema";
import { editLocationCategory } from "../api";
import { mapLocationCategoriesToApi } from "../mapDataToApi";
import LocationCategoryForm from "./LocationCategoryForm";

function EditLocationCategory({ onClose, selectedLocationCategoryData, onSuccess }) {
    const [selectedCategoryData, setSelectedCategoryData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [errorList, setErrorList] = useState(null);
    const [errors, setErrors] = useState(null);
    const [nameArError, setNameArError] = useState();
    const [nameEnError, setNameEnError] = useState();
    const [codeError, setCodeError] = useState();

    const handleLocationCategoryChange = (e) => {
        const { name, value } = e?.target;
        setSelectedCategoryData({
            ...selectedCategoryData,
            [name]: value,
        });
        yup.reach(validationSchema, name)
            .validate(value)
            .then(() => setErrorList({ ...errorList, [name]: "" }))
            .catch((err) => setErrorList({ ...errorList, [name]: err.message }));
    };

    const handleEditLocationCategory = async (e) => {
        e.preventDefault();

        try {
            const response = await validationSchema
                .validate(selectedCategoryData, { abortEarly: false })
                .then(async () => {
                    setIsLoading(true);
                    editLocationCategory(
                        mapLocationCategoriesToApi(
                            selectedCategoryData,
                            selectedLocationCategoryData?.id
                        ),
                        selectedLocationCategoryData?.id
                    )
                        .then(() => {
                            setIsLoading(false);
                            onSuccess(selectedCategoryData.arabicName);
                        })
                        .catch((error) => {
                            setIsLoading(false);
                            setErrors(error);
                            if (error?.name_ar) {
                                setNameArError(error?.name_ar[0]);
                            }
                            if (error?.name_en) {
                                setNameEnError(error?.name_en[0]);
                            }
                            if (error?.code) {
                                setCodeError(error?.code[0]);
                            }
                        });
                });
        } catch (error) {
            const errorMessage = error?.inner?.reduce(
                (acc, error) => ({
                    ...acc,
                    [error?.path]: error?.message,
                }),
                {}
            );
            setErrorList(errorMessage);
        }
    };

    useEffect(() => {
        setSelectedCategoryData({
            arabicName: selectedLocationCategoryData?.nameAr,
            englishName: selectedLocationCategoryData?.nameEn,
            code: selectedLocationCategoryData?.code,
        });
    }, [selectedLocationCategoryData]);
    useEffect(() => {
        setNameArError(null);
    }, [selectedCategoryData?.arabicName]);
    useEffect(() => {
        setNameEnError(null);
    }, [selectedCategoryData?.englishName]);
    useEffect(() => {
        setCodeError(null);
    }, [selectedCategoryData?.code]);
    return (
        <LocationCategoryForm
            locationCategoryData={selectedCategoryData}
            handleLocationCategoryChange={handleLocationCategoryChange}
            onClose={onClose}
            handleLocationCategorySubmit={handleEditLocationCategory}
            errors={errors}
            errorList={errorList}
            nameArError={nameArError}
            nameEnError={nameEnError}
            codeError={codeError}
            isLoading={isLoading}
            buttonName="Edit"
        />
    );
}

export default EditLocationCategory;
